
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/monitoring",
      function () {
        return require("private-next-pages/events/monitoring.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/monitoring"])
      });
    }
  